import { createFileRoute } from '@tanstack/react-router';

import { RouterContext } from '~/types/router.type';

import { i18n } from '~/utils';
import { getRouteHead } from '~/utils/routeUtils';

import { DeliveryNote } from '~/components/deliveries/deliveryNote/DeliveryNote';

import { getDeliveryNote } from './-routeParams';

const title = i18n.t(($) => $.pageTitle.detail, { ns: 'delivery' });

export const Route = createFileRoute('/(main)/deliveries/all/$deliveryId/')({
  beforeLoad: ({ context, params }) => getDeliveryNote({ context, params }),
  component: DeliveryNote,
  head: ({ loaderData }: { loaderData?: RouterContext }) =>
    getRouteHead(`${title} ${loaderData?.pageData?.title ?? ''}`),
  loader: ({ context }) => context,
  staticData: {
    AppBar: {
      title,
    },
  },
});
